import { AxisScale, AxisTop } from '@visx/axis';
import { QUALITY_TIMELINE_AXIS } from '../../consts';
import { useFormatTimelineAxisTick } from './useFormatTimelineAxisTick';

export type TimelineAxisTopProps = {
  scale: AxisScale;
  stroke: string;
  tickStroke: string;
  tickLabelFill: string;
  /** IANA timezone for tick labels; omit for browser-local wall time. */
  timeZone?: string;
};

/**
 * Top time axis for the stream availability timeline: fewer ticks when zoomed far out, and label granularity follows visible range.
 */
export function TimelineAxisTop({
  scale,
  stroke,
  tickStroke,
  tickLabelFill,
  timeZone,
}: TimelineAxisTopProps) {
  const formatTimelineTick = useFormatTimelineAxisTick();
  const [domainStart, domainEnd] = scale.domain() as [Date, Date];
  const visibleDurationMs = domainEnd.getTime() - domainStart.getTime();
  const visibleHours = visibleDurationMs / (1000 * 60 * 60);

  const numTicksTarget =
    visibleHours > QUALITY_TIMELINE_AXIS.fewTicksThresholdHours
      ? QUALITY_TIMELINE_AXIS.numTicksWhenWide
      : QUALITY_TIMELINE_AXIS.numTicksDefault;

  return (
    <AxisTop
      scale={scale}
      stroke={stroke}
      tickStroke={tickStroke}
      tickFormat={(val) => formatTimelineTick(visibleHours, val as Date | number, timeZone)}
      numTicks={numTicksTarget}
      tickLabelProps={() => ({
        fill: tickLabelFill,
        fontSize: 12,
        textAnchor: 'middle',
        dy: '-0.25em',
      })}
    />
  );
}
